// SOME OF THE EVENTS THAT WE ARE TRACKING ALREADY HAS ACTIONS TYPES THAT ARE FIRED
// WHEN THE EVENT HAPPENS SO WE ARE JUST HOOKING INTO THSOSE ACTION FOR ANALYTICS
// BUT FOR THOSE EVENTS THAT DONT FIRE ACTIONS THEY ARE DEFINED HERE

import isEmpty from 'lodash/isEmpty';

import {
  TREK_PAYMENT_SUCCESS,
  LODGE_BOOKING_REQUEST_SUCCESS,
  FLIGHT_BOOKING_SUCCESS,
  TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW,
  ON_EMAIL_SUBSCRIPTION,
  ON_FLIGHTS_SEARCH,
  ON_FLIGHTS_BOOK_BUTTON_PRESS,
  ON_FLIGHTS_REVIEW_VIEW,
  ACTIVATE_OPTIMIZE,
  ON_PAYPAL_BUTTON_CLICK,
  ON_HG_CREDIT_APPLY_SUCCESS,
} from './types.js';
import { getUserIdFromStorage } from '../../lib/utils';

export const onTrekPaymentSuccess = revenue => (dispatch, getState) => {
  // Dispatch an event for trek booking success
  dispatch(trekPaymentSuccess(revenue));

  // Dispatch events for individual lodges
  const { lodgings } = getState().trekPayment;
  const { paymentType } = revenue;

  lodgings.forEach(lodge => {
    const { revenue, name, address } = getDataFromLodge(lodge, paymentType);
    dispatch(onLodgeBookingRequestSuccess(revenue, name, address));
  });
};
export function trekPaymentSuccess(revenue) {
  return {
    type: TREK_PAYMENT_SUCCESS,
    amount: revenue.total_amount,
    paymentType: transformPaymentType(revenue.paymentType),
  };
}

export function onLodgeBookingRequestSuccess(amount, lodgeName, lodgeAddress) {
  return {
    type: LODGE_BOOKING_REQUEST_SUCCESS,
    amount,
    lodgeName: getFormatedLodgeName(lodgeName, lodgeAddress),
  };
}

export function trackFlightbookingSuccess(amount, flightType = 'Only Flight') {
  return {
    type: FLIGHT_BOOKING_SUCCESS,
    amount,
    flightType,
  };
}

// Utils =======================================
const getFormatedLodgeName = (name, address) => {
  const isHoneyGuide = getUserIdFromStorage() === 'aabbccddeeff';

  let lodgeName = name ? name : '';

  if (address) lodgeName = lodgeName + ', ' + address + ' (lodge)';
  if (isHoneyGuide) lodgeName = lodgeName + '(HoneyGuide)';

  return lodgeName;
};

const getDataFromLodge = (lodge, paymentType) => {
  const { name, address, meal_plan, room_type } = lodge;
  const { amount } = meal_plan[room_type];

  return {
    revenue: { amount, paymentType },
    name,
    address,
  };
};

function transformPaymentType(paymentType) {
  if (paymentType) {
    if (paymentType.toLowerCase() === 'n') return 'non-refundable';
    if (paymentType.toLowerCase() === 'r') return 'refundable';
  }

  return 'unknown';
}

export const trackTrekPaymentReviewPageview = () => (dispatch, getState) => {
  const trek = getState().selectedTrek.trek;
  const trekName = !isEmpty(trek) ? trek.name : 'unknown';
  dispatch(onTrekPaymentPageview(trekName));
};

function onTrekPaymentPageview(trekName) {
  return {
    type: TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW,
    trekName,
  };
}

export const onEmailSubscription = () => ({
  type: ON_EMAIL_SUBSCRIPTION,
});

export const trackFlightSearch = ({ startDate }) => ({
  type: ON_FLIGHTS_SEARCH,
  startDate,
});

export const trackFlightBookButtonPress = () => ({
  type: ON_FLIGHTS_BOOK_BUTTON_PRESS,
});

export const trackFlightReviewView = () => ({
  type: ON_FLIGHTS_REVIEW_VIEW,
});

export const activateGoogleOptimize = () => ({
  type: ACTIVATE_OPTIMIZE,
});

export const trackPaypalButtonClick = () => ({
  type: ON_PAYPAL_BUTTON_CLICK,
});

export const trackHGCreditApplySuccess = () => ({
  type: ON_HG_CREDIT_APPLY_SUCCESS,
});



// WEBPACK FOOTER //
// ./src/redux/actions/analyticsEventActions.js